import { Component, Input } from '@angular/core';

import { BaseComponentClassDirective } from '~shared/classes/base-component.class';
import { ApiConfig } from '~shared/constants/api.config';

@Component({
  selector: 'app-email-sent',
  templateUrl: './email-sent.component.html',
  styleUrls: ['./email-sent.component.scss']
})
export class EmailSentComponent extends BaseComponentClassDirective {
  @Input() title: string;
  @Input() message: string;
  @Input() returnToText: string;
  @Input() returnToLink: string;
  @Input() tryAgainLink: string;

  public templateOptions = {
    emailImageUrl: `${ApiConfig.CDN_IMAGE_URL()}/sended-email.png`,
  };
}
